import { TUTORIAL_PAGES } from "app/how-to-play/tutorial-pages";
import TutorialSlide from "app/how-to-play/TutorialSlide";
import FullScreenPanel from "app/ui/FullScreenPanel";
import MenuButton from "app/ui/MenuButton";
import cn from "app/util/classnames";
import { useState } from "react";

interface HowToPlayProps {
  showPracticeButton: boolean;
  onDismiss?: (startPracticeRound: boolean) => void;
}

export default function HowToPlay(props: HowToPlayProps) {
  const [slideIndex, setSlideIndex] = useState<number>(0);
  const isFirstSlide = slideIndex === 0;
  const lastSlideIndex = TUTORIAL_PAGES.length - 1;
  const isLastSlide = slideIndex === lastSlideIndex;

  function dismiss(startPracticeRound: boolean) {
    props.onDismiss?.(startPracticeRound);
  }

  function goToIndex(number: number) {    
    setSlideIndex(number);
  }

  return (
    <FullScreenPanel
      panelClassName="md:min-h-140"
      childDivClassName="flex-1 overflow-y-clip"
      onClose={() => dismiss(false)}
      heading="How to Play"
    >
      <div // Main flex box
        className="flex-1 w-full flex flex-col"
      >
        <div // Page number holder
          className={cn(
            "flex flex-col items-center justify-start gap-0.5",
            "mb-1.5 text-center",
          )}
        >
          <p className="text-sm">{slideIndex + 1} / 7</p>
        </div>
        <div // Main section
          className="flex-1 flex justify-center"
        >
          {TUTORIAL_PAGES.map(({ ImgContent, TextContent }, pageIndex) => (
            <TutorialSlide
              key={pageIndex}
              imgContent={ImgContent}
              textContent={TextContent}
              active={slideIndex === pageIndex}
            ></TutorialSlide>
          ))}
        </div>
        <div // Button container
          className={cn(
            "flex-none mt-1 pt-6 lg:p-0",
            "flex items-end justify-center gap-2.5",
          )}
        >
          {!isFirstSlide && (
            <MenuButton
              className="max-w-30"
              onClick={() => {
                goToIndex(Math.max(slideIndex - 1, 0));
              }}
            >
              Back
            </MenuButton>
          )}
          {isLastSlide && (
            <MenuButton className="max-w-30" onClick={() => dismiss(false)}>
              Close
            </MenuButton>
          )}
          {!isLastSlide && (
            <MenuButton
              className="max-w-30"
              onClick={() =>
                goToIndex(Math.min(slideIndex + 1, lastSlideIndex))
              }
            >
              Next
            </MenuButton>
          )}
          {/* Practice button does not appear if the user is already doing the
              practice level.
          */}
          {isLastSlide && props.showPracticeButton && (
            <MenuButton className="max-w-30" onClick={() => dismiss(true)}>
              Practice
            </MenuButton>
          )}
        </div>
      </div>
    </FullScreenPanel>
  );
}
